export default __webpack_public_path__ + "images/icon-current-location.016f55a1.svg";